define(
  'favoritesLoader',[],
  () => {
    'use strict';

    const favoriteElements = document.querySelectorAll('[data-favorite-trigger]');

    /*
     * We need to define the event name for mobile and desktop because we need to dispatch the event
     * after loading the favorites js resources, also favorites js works with mousedown for desktop and click
     * for mobile.
     *
     * Example desktop: user clicks on favorites button -> load the favorites js ->
     *                  we dispatch mousedown event -> favorites js working the event
     * Example mobile: user touch the favorites button -> load the favorites js ->
     *                  we dispatch click event -> favorites js working the event
     *
     * Notes: The reason to not use mouseover is that for mobile not working as expected because the
     *        mouse over event needs to press the screen and this dispatch the touch start event first, and this
     *        not working in the same way on desktop, desktop just needs to pass the pointer over the button.
     */
    const isTouchScreen = Object.prototype.hasOwnProperty.call(window, 'ontouchstart');
    const eventName = isTouchScreen ? 'click' : 'mousedown';

    /**
    * @private
    * initFavoritesComponent: inits the Favorites component on the title section
    */

    function initFavoritesComponent(event) {
      if (!event && !event.currentTarget) {
        return;
      }

      event.stopPropagation();

      favoriteElements.forEach((item) => {
        item.removeEventListener(eventName, initFavoritesComponent);
      });

      const buttonTarget = event.currentTarget;

      require(
        ['favoritesInit'],
        (favoritesInit) => {
          favoritesInit.init();

          const eventToDispatch = new Event(eventName);
          buttonTarget.dispatchEvent(eventToDispatch);
        }
      );

      event.preventDefault();
    }

    /**
    * @private
    * Init: update Styles
    */
    function updateStyleFavoriteAnchor() {
      const pendingItems = document.cookie.match(/pendingSaveItem=([^;]+)/);
      const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];
      const arrayFavorites = cookieFavorites.map((item) => JSON.parse(item).id);
      favoriteElements.forEach((item) => {
        const itemIndex = arrayFavorites.indexOf(item.dataset.id);
        if (itemIndex >= 0) {
          const anchorSaved = item.parentElement.querySelector('.nhs_favSaved');
          anchorSaved.style.display = 'block';

          const anchorUnSave = item.parentElement.querySelector('.nhs_favUnsave');
          anchorUnSave.style.display = 'none';
        }
      });
    }

    /**
    * @private
    * Init: Init the component
    */

    function Init() {
      favoriteElements.forEach((item) => {
        item.addEventListener(eventName, initFavoritesComponent);
      });
      updateStyleFavoriteAnchor();
    }

    if (document.readyState === 'complete') {
      Init();
    } else {
      window.addEventListener('load', Init);
    }
  }
);

